export const CARD_FORM_TYPES = {
  new: "new",
  onFile: "onFile",
  swipe: "swipe",
  manual: "manual",
};
